import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { ProductScheme } from "client-v2";
import { useSelector } from "react-redux";
import { State } from "../../redux";
import { useNavigate } from "react-router";

import { Text, ColorV2, Button } from "@adoptaunabuelo/react-components";
import ContainerSection from "../../components/landing/ContainerSection";
import EscrituraIcon from "../../assets/logo/Escritura";

const DataView = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 40%;
	${media.lessThan("medium")`
		flex: 1;
        margin: 96px 0px;
		width: unset;
		justify-content: flex-start;
    `}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;

const Header = (props: Props) => {
	const navigate = useNavigate();
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const config = useSelector((state: State) => state.location.config);
	const [packAmount, setPackAmount] = useState(10);

	useEffect(() => {
		if (config && config.attributes && config.attributes.PACK_INFO) {
			const packInfo = config.attributes.PACK_INFO;
			setPackAmount(packInfo.amount);
		}
	}, []);

	return (
		<ContainerSection
			style={{
				minHeight: "100vh",
				paddingTop: 0,
				paddingBottom: 0,
			}}
			backgroundImage={`url(${require(isMobile
				? "../../assets/images/background/pack-mobile.webp"
				: "../../assets/images/background/pack.webp")})`}
		>
			<DataView>
				<Text type="h2" weight="regular">
					Colabora enviando una carta con el{" "}
					<span style={{ fontWeight: 600 }}>
						Pack Solidario de{" "}
						<EscrituraIcon
							height={isMobile ? 39 : 50}
							width={isMobile ? 144 : 184}
							style={{ verticalAlign: "middle" }}
						/>
					</span>
				</Text>
				<Row
					style={{
						marginTop: 24,
						marginBottom: 48,
						gap: 8,
						alignItems: "center",
					}}
				>
					<Text
						type="h6"
						style={{ color: ColorV2.text.neutralMedium }}
					>
						{packAmount} personas ya tienen su pack
					</Text>
				</Row>
				{!isMobile && (
					<Button
						style={{
							width: isMobile ? "100%" : "fit-content",
							backgroundColor: ColorV2.surface.primary,
							display: isMobile ? "none" : "flex",
						}}
						onClick={() =>
							navigate("/shop/?id=" + props.product.objectId, {
								state: {
									product: props.product,
									view: props.view,
								},
							})
						}
					>
						Quiero mi Pack Solidario
					</Button>
				)}
			</DataView>
		</ContainerSection>
	);
};
export default Header;
export interface Props {
	product: ProductScheme;
	view: string;
}
